// import the API url
import { CONTACT_CREATION_ENDPOINT } from './config';

/**
 * Generic fetch function to send data to the LoanForce contact creation API
 *
 * @param {Object} dataToSend - data for creating a new contact in LoanForce
 * @return {Object} apiResponse - the response from the API :o
 */
function postToLoanForce(dataToSend) {
  const apiResponse = fetch(CONTACT_CREATION_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(dataToSend),
  });

  return apiResponse;
}

export default postToLoanForce;



// WEBPACK FOOTER //
// ./scripts/util/postToLoanForce.js